// index.js
import React from 'react';
import ReactDOM from 'react-dom/client'; // 'react-dom/client'からインポート
import App from './App';
import { Provider } from 'react-redux';
import store from './store';

const root = ReactDOM.createRoot(document.getElementById('root')); // createRootを使用
root.render(
    <Provider store={store}>
        <App />
    </Provider>
);
